(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
/* ═══════════════════════════════════════════════════════════════
   MEGA MENU INTERACTIONS — keyboard, click-on-touch, Escape close,
   open-state class on .hdr-nav so the backdrop fades in.
   Hover behavior is pure CSS; this script just ensures the menu
   works with focus, touch, and reduced-pointer environments.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  var nav = document.getElementById('hdr-nav');
  if (!nav) return;

  var items = nav.querySelectorAll('.hdr-nav-item[data-mega]');
  var openItem = null;
  var hoverTimer = null;

  function openMega(item) {
    if (openItem && openItem !== item) closeMega(openItem);
    item.classList.add('is-open');
    var trigger = item.querySelector('.hdr-nav-link');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    nav.classList.add('is-mega-open');
    openItem = item;
  }

  function closeMega(item) {
    if (!item) return;
    item.classList.remove('is-open');
    var trigger = item.querySelector('.hdr-nav-link');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (openItem === item) openItem = null;
    if (!nav.querySelector('.hdr-nav-item.is-open')) {
      nav.classList.remove('is-mega-open');
    }
  }

  items.forEach(function (item) {
    var trigger = item.querySelector('.hdr-nav-link');
    if (!trigger) return;

    // Hover → mark nav as open so backdrop fades in. CSS handles the panel.
    item.addEventListener('mouseenter', function () {
      clearTimeout(hoverTimer);
      nav.classList.add('is-mega-open');
      openItem = item;
    });
    item.addEventListener('mouseleave', function () {
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () {
        if (!item.matches(':hover') && !item.classList.contains('is-open')) {
          if (openItem === item) openItem = null;
          if (!nav.querySelector('.hdr-nav-item:hover, .hdr-nav-item.is-open')) {
            nav.classList.remove('is-mega-open');
          }
        }
      }, 120);
    });

    // Click on the top-level link: on touch devices, first tap opens, second navigates.
    trigger.addEventListener('click', function (e) {
      var isTouch = window.matchMedia('(hover: none)').matches;
      if (!isTouch) return; // desktop: let the link navigate normally
      if (!item.classList.contains('is-open')) {
        e.preventDefault();
        openMega(item);
      }
      // If already open, the link click goes through to navigate.
    });

    // Keyboard: Enter/Space toggles, ArrowDown opens and focuses first link.
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        openMega(item);
        var firstLink = item.querySelector('.hdr-mega-col__link, .hdr-mega-feature');
        if (firstLink) firstLink.focus();
      }
    });
  });

  // Escape closes any open mega.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openItem) {
      var trigger = openItem.querySelector('.hdr-nav-link');
      closeMega(openItem);
      if (trigger) trigger.focus();
    }
  });

  // Click outside closes.
  document.addEventListener('click', function (e) {
    if (openItem && !openItem.contains(e.target)) {
      closeMega(openItem);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
